import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RubricsState {
  viewMode: 'grid' | 'table';
  currentTab: number;
  searchQuery: string;
  sortBy: 'title' | 'updated_at';
  sortOrder: 'asc' | 'desc';
}

const initialState: RubricsState = {
  viewMode: 'table',
  currentTab: 0,
  searchQuery: '',
  sortBy: 'updated_at',
  sortOrder: 'desc',
};

const rubricsSlice = createSlice({
  name: 'rubrics',
  initialState,
  reducers: {
    setViewMode: (state, action: PayloadAction<'grid' | 'table'>) => {
      state.viewMode = action.payload;
    },
    setCurrentTab: (state, action: PayloadAction<number>) => {
      state.currentTab = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setSortBy: (state, action: PayloadAction<'title' | 'updated_at'>) => {
      state.sortBy = action.payload;
    },
    setSortOrder: (state, action: PayloadAction<'asc' | 'desc'>) => {
      state.sortOrder = action.payload;
    },
  },
});

export const { setViewMode, setCurrentTab, setSearchQuery, setSortBy, setSortOrder } =
  rubricsSlice.actions;

export default rubricsSlice.reducer;
